
export default function DiscreteTabsViewHandler(tabs, ...viewLists) {
    [].forEach.call(tabs, function (tab, index) {
        tab.addEventListener('click', function () {
            setActiveTab(index);
        });
    });

    function setActiveTab(activeIndex) {
        [].forEach.call(tabs, function (tab, index) {
            if (index === activeIndex) {
                tab.classList.add('active');
            } else {
                tab.classList.remove('active');
            }
        });

        viewLists.forEach(viewList => {
            [].forEach.call(viewList, function (view, index) {
                const isActive = index === activeIndex;

                if ('function' === typeof view) {
                    view(isActive);
                    return;
                }

                if (isActive) {
                    view.classList.add('active');
                } else {
                    view.classList.remove('active');
                }
            });
        });
    }
}
